import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'medsurf-media-library',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './media-library.component.html',
    styleUrls: ['./media-library.component.scss'],
    standalone: false
})
export class MediaLibraryComponent {
}
